import { useApi } from '../useApi';
import { baseUrl, ServiceName } from '../urlHelper';


const LOGOUT_URL = '/logout';

export const useLogoutUserAPI = () => {
    const { apiCall } = useApi();

    const logoutUser = async (): Promise<void> => {
        const url = `${baseUrl(ServiceName.USERS)}${LOGOUT_URL}`;

        try {
            await apiCall<void>(url, {
                method: 'POST'
            });
        } catch (error) {
            console.error('[ERROR] Something went wrong during logout. Reason: ', error);
        }
    };

    return { logoutUser };
};
